export default __webpack_public_path__ + "static/media/ic-crops-legume-vege.ef94f1f4.svg";